import http from '../utils/http';

export default class UserService {
  static async me() {
    const { data } = await http.get('/usuarios/me');
    return data;
  }

  static async listAlocations() {
    const { data } = await http.get('/usuarios/alocacoes');
    return data;
  }

  static async listCostCenters() {
    const { data } = await http.get('/usuarios/centros-de-custos');
    return data.map((el) => ({
      id: el,
      nome: el,
    }));
  }

  static async listPaychecks(costCenter, page) {
    const params = { centroDeCusto: costCenter, page };
    const { data } = await http.get('/usuarios/contracheques', { params });
    return data;
  }

  static async listReportIncomes(page) {
    const params = { page };
    const { data } = await http.get('/usuarios/informe-de-rendimentos', { params });
    return data;
  }
}
